var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1628_1594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9991 0C21.0826 0 0 21.0842 0 47C0 72.9158 21.0826 94 46.9991 94C72.9156 94 94 72.9158 94 47C94 21.0842 72.9156 0 46.9991 0ZM46.9991 87.8359C24.4823 87.8359 6.16405 69.5168 6.16405 47C6.16405 24.483 24.4821 6.16429 46.9991 6.16429C69.5161 6.16429 87.8352 24.4832 87.8352 47C87.8355 69.5168 69.5158 87.8359 46.9991 87.8359Z",
    fill: "#00BF57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0148 31.6136L39.779 55.8482L29.9821 46.0534C28.7782 44.8509 26.8279 44.8502 25.624 46.0541C24.4196 47.2585 24.4196 49.209 25.624 50.4129L37.6003 62.3873C38.2021 62.9884 38.9905 63.2892 39.779 63.2892C40.5674 63.2892 41.3579 62.9884 41.9595 62.3864C41.9614 62.3838 41.9628 62.3812 41.9659 62.3781L68.3726 35.9717C69.577 34.7685 69.577 32.8165 68.3726 31.6133C67.1689 30.4094 65.2173 30.4094 64.0148 31.6136Z",
    fill: "#00BF57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1628_1594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.d4b1aeef7b11626182478403299962d4.svg";
export { ForwardRef as ReactComponent };